module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/2-35b42f6ceff3b09cb94e2a7a73ef5f4d.webp";